import React from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { CalendarDaysIcon, ContactIcon, LayoutDashboardIcon, PresentationIcon, GlobeIcon, ShuffleIcon, UsersIcon } from "lucide-react";
import { currentProgramDay, PROGRAM_DAYS } from "../../utils/dates";
const nav = [{
  to: "/organizer",
  label: "Overview",
  icon: LayoutDashboardIcon,
  match: (p: string) => p === "/organizer"
}, {
  to: "/organizer/groups",
  label: "Groups",
  icon: UsersIcon,
  match: (p: string) => p.startsWith("/organizer/groups")
}, {
  to: "/organizer/people",
  label: "People",
  icon: ContactIcon,
  match: (p: string) => p.startsWith("/organizer/people")
}, {
  to: "/organizer/program",
  label: "Program & schedule",
  icon: CalendarDaysIcon,
  match: (p: string) => p.startsWith("/organizer/program")
}, {
  to: "/organizer/demo-day",
  label: "Demo Day",
  icon: PresentationIcon,
  match: (p: string) => p.startsWith("/organizer/demo-day")
}, {
  to: "/organizer/draw/subjects",
  label: "Draws",
  icon: ShuffleIcon,
  match: (p: string) => p.startsWith("/organizer/draw")
}, {
  to: "/",
  label: "Public site",
  icon: GlobeIcon,
  match: () => false
}];
function FlagBand() {
  return <div className="flex h-1" aria-hidden="true" data-id="element-137" data-mp="22m82xg22z06d">
      <span className="flex-1 bg-brgreen" data-id="element-138" data-mp="22lgin1dxoove" />
      <span className="flex-1 bg-bryellow" data-id="element-139" data-mp="26ntmfk94ecpj" />
      <span className="flex-1 bg-saffron" data-id="element-140" data-mp="26ms0gkqkg5t1" />
      <span className="flex-1 bg-ingreen" data-id="element-141" data-mp="26lgv4ghh2pzt" />
    </div>;
}
function dayLabel(): string {
  const day = currentProgramDay();
  if (day < 1) return "Starts Oct 7";
  if (day <= PROGRAM_DAYS) return `Day ${day} of ${PROGRAM_DAYS}`;
  if (day === PROGRAM_DAYS + 1) return "Demo Day";
  return "Program complete";
}
export function AppShell() {
  const {
    pathname
  } = useLocation();
  return <div className="flex min-h-screen w-full flex-col bg-paper lg:flex-row" data-id="element-142" data-mp="1nr1vqpr90vbg">
      <aside className="bg-waves flex shrink-0 flex-col text-white lg:sticky lg:top-0 lg:h-screen lg:w-64" data-id="element-143" data-mp="3e1wnk0rv3n40">
        <FlagBand data-id="element-144" data-mp="3i274u9l3tzy6" />
        <div className="flex items-center justify-between gap-4 px-5 py-4 lg:block lg:py-6" data-id="element-145" data-mp="3i0no6hvjdmvv">
          <Link to="/organizer" className="block" data-id="element-146" data-mp="us6fq3fq1fi8">
            <p className="text-[15px] font-bold leading-tight" data-id="element-147" data-mp="pueolbmwhxf3">Engineering Entrepreneurship Challenge</p>
            <p className="mt-0.5 text-xs text-white/60" data-id="element-148" data-mp="luw76puag4h0">LINK · Mahindra · Circuit Launch</p>
          </Link>
          <span className="rounded-md bg-bryellow px-2 py-1 text-xs font-bold text-navy lg:mt-4 lg:inline-block" data-id="element-149" data-mp="gw2yrbtuz3np">
            {dayLabel()}
          </span>
        </div>
        <nav aria-label="Main" className="flex gap-1 overflow-x-auto px-3 pb-3 lg:flex-col lg:overflow-visible lg:pb-0" data-id="element-150" data-mp="19ixankcm0upk">
          {nav.map(item => {
          const active = item.match(pathname);
          const Icon = item.icon;
          return <Link key={item.to} to={item.to} aria-current={active ? "page" : undefined} className={`flex shrink-0 items-center gap-3 whitespace-nowrap rounded-lg px-3 py-2 text-sm font-medium transition-colors duration-150 ${active ? "bg-white/15 text-white" : "text-white/70 hover:bg-white/5 hover:text-white"}`} data-id="element-151" data-mp="zrt4na4wwk6v">
                <Icon className="h-4 w-4" aria-hidden="true" data-id="element-152" data-mp="29r3yt6q4c82m" />
                {item.label}
              </Link>;
        })}
        </nav>
        <p className="mt-auto hidden px-5 py-5 text-xs leading-relaxed text-white/50 lg:block" data-id="element-153" data-mp="2dujvg326u8fb">
          Demo Day · October 13, 2026
          <br data-id="element-154" data-mp="2nr4zom6dvfi3" />
          Prizes: $1,500 · $750 · $300
        </p>
      </aside>
      <div className="min-w-0 flex-1" data-id="element-155" data-mp="2np1zj9bio5zn">
        <Outlet data-id="element-156" data-mp="2shv682qjpoed" />
      </div>
    </div>;
}